(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define(function() {
			return factory(root);
		});
	} else if (typeof exports === 'object') {
		module.exports = factory;
	} else {
		root.Imgness = factory(root);
	}
})(this, function (root) {

	'use strict';

	var VERSION = "1.0", store = [], storeResponsive = [], settings = {}, attr = {}, defaults = {};
	//lodash dependency
	var _ = window._;

	attr = {
		'img' : 'data-lazy-img',
		'resp' : 'data-responsive',
		'bg' : 'data-lazy-bg'
	};

	defaults = {
		offsetH : 200,
		offsetV : 200,
		eventDelay : 250,
		breakpoint : {
			'mobile':{"value":"mobile","query":"(max-width:703px)"},
			'tablet':{"value":"tablet","query":"(min-width:704px)"},
			'desktop':{"value":"desktop","query":"(min-width:960px)"}
		}
	};

	var debounce = function (func, wait, atBegin, atEnd) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!atBegin || atEnd)
					func.apply(context, args);
			};
			var callNow = atBegin && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	var addEvent = function(el,event,fn) {
		if (document.addEventListener) {
			el.addEventListener(event, fn, false);
		} else {
			el.attachEvent('on'+event, fn);
		}
	};

	var removeEvent = function(el,event,fn) {
		if (document.removeEventListener) {
			el.removeEventListener(event, fn);
		} else {
			el.detachEvent('on'+event, fn);
		}
	};

	var bindAllEvents = function() {
		bindEvents();
		bindResponsiveEvents();
	};

	var bindEvents = function() {
		addEvent(window,'scroll',render);
		addEvent(window,'resize',render);
	};

	var bindResponsiveEvents = function(){
		addEvent(window,'scroll',renderResponsive);
		addEvent(window,'resize',renderResponsive);
	};

	var isInView = function(el){
		var view = {
			l: 0 - settings.offsetH,
			t: 0 - settings.offsetV,
			b: (root.innerHeight || document.documentElement.clientHeight) + settings.offsetV,
			r: (root.innerWidth || document.documentElement.clientWidth) + settings.offsetH
		};
		var rect = el.getBoundingClientRect();
		return (rect.right >= view.l && rect.bottom >= view.t && rect.left <= view.r && rect.top <= view.b);
	};

	var noMedia = function(isResponsive) {
		if (isResponsive && storeResponsive.length===0) {
			removeEvent(window,'scroll',renderResponsive);
			removeEvent(window,'resize',renderResponsive);
			return true;
		}

		if(!isResponsive && store.length===0){
			removeEvent(window,'scroll',render);
			removeEvent(window,'resize',render);
			return true;
		}
		return false;
	};

	var getCurrentViewport = function() {
		if(window.matchMedia(settings.breakpoint.desktop.query).matches){
			return settings.breakpoint.desktop.value;
		} else if (window.matchMedia(settings.breakpoint.tablet.query).matches) {
			return settings.breakpoint.tablet.value;
		} else {
			return settings.breakpoint.mobile.value;
		}
	};

	var hasRightViewport = function(el) {
		var currViewport = getCurrentViewport();
		return (el.getAttribute(attr.resp)===currViewport);
	};

	var renderAll = function() {
		render();
		renderResponsive();
	};

	var render = function() {
		if(noMedia(false)){return;}

		_.each(store,function(el){
			el.style.display = 'block';
			if(isInView(el)){
				var isImg = el.getAttribute(attr.img)!==null;
				var src = el.getAttribute(isImg?attr.img:attr.bg);

				if(isImg) {
					el.setAttribute('src',src);
				} else {
					el.style.backgroundImage = "url(" + src + ")";
				}

				el.removeAttribute(isImg?attr.img:attr.bg);

				//remove element from the array
				store = _.without(store,el);
			}
		});
	};

	var renderResponsive = function() {
		if(noMedia(true)){return;}

		_.each(storeResponsive,function(el){
			if(isInView(el) && hasRightViewport(el)){
				var src = el.getAttribute('data-src');
				var elViewport = el.getAttribute(attr.resp);
				el.setAttribute('src',src);
				el.className += " " + "imgness-"+elViewport + " ";
				el.removeAttribute('data-src');
				el.removeAttribute(attr.resp);

				//remove element from the array
				storeResponsive = _.without(storeResponsive,el);
			}
		});
	};

	var setStores = function() {
		store = document.querySelectorAll('img['+attr.img+'], ['+attr.bg+']');
		storeResponsive = document.querySelectorAll('['+attr.resp+']');
	};

	var refresh = function() {
		var oldStore = store;
		var oldStoreResponsive = storeResponsive;
		setStores();
		if(oldStore.length===0 && store.length>0){
			bindEvents();
		}
		if(oldStoreResponsive.length===0 && storeResponsive.length>0){
			bindResponsiveEvents();
		}
		renderAll();
	};

	var init = function(options) {
		settings = _.extend({},defaults,options);
		setStores();
		bindAllEvents();
		renderAll();
	};

	var getStores = function () {
		console.log(store.length);
		console.log(store);
		console.log(storeResponsive.length);
		console.log(storeResponsive);
	};

	return {
		VERSION:VERSION,
		init:init,
		refresh:refresh,
		getStores:getStores
	};

});